import { throttle } from 'throttle-debounce'

const cacheKey = 'offset'

// 重置 fixed 状态
export const resetElFixed = (el) => {
  if (!el.dataset.fixed) {
    return
  }
  // 移除占位空白
  const padDiv = el.previousSibling
  if (padDiv && padDiv.id === 'fixed-pad-div') {
    padDiv.parentNode.removeChild(padDiv)
  }
  // 恢复以前的位置样式
  el.style.position = el.dataset.position
  el.style.top = el.dataset.top
  el.style.zIndex = el.dataset.zIndex
  el.classList.remove(el.dataset.cls)
  // 移除标记
  delete el.dataset.fixed
}

/**
 * 生成 v-fixed 自定义指令
 * @param  {String} options.selector scroll element selector
 * @param  {Number} options.delay    throttle delay
 * @return {Object}                  返回 fixed 指令
 */
export default ({ selector = '', delay = 100 } = {}) => {
  // 主要是unbind 时需要去除scroll 事件； 采用缓存事件

  let scrollListener = null
  let scrollElement = null

  // 处理当前绑定元素 置顶样式
  let padDiv = null

  const elListener = (el, onFixedChange) => {
    // 处理滚动位置
    const isFixed = el.dataset.fixed === '1'
    const ele = isFixed ? padDiv : el // 确定是否在视图内的元素
    const rect = ele.getBoundingClientRect()

    const top = parseInt(el.dataset[cacheKey] || 0, 10)
    const cls = el.dataset.cls
    if (rect.top <= top) {
      // 需要置顶
      if (el.dataset.fixed === '1') {
        return
      }
      padDiv = document.createElement('div')
      // 占位空白的宽高
      padDiv.id = 'fixed-pad-div'
      const width = el.clientWidth
      const height = el.clientHeight
      padDiv.style.width = `${width}px`
      padDiv.style.height = `${height}px`

      // 缓存以前的值，以待恢复
      el.dataset.position = el.style.position
      el.dataset.top = el.style.top
      el.dataset.zIndex = el.style.zIndex
      // 置顶top
      el.style.position = 'fixed'
      el.style.top = `${top / 12}rem`
      el.style.zIndex = 1000

      cls && el.classList.add(cls)

      const parent = el.parentNode
      parent && parent.insertBefore(padDiv, el)

      el.dataset.fixed = '1'
      onFixedChange && onFixedChange(true)
    } else {
      // 移除置顶
      resetElFixed(el)
      onFixedChange && onFixedChange(false)
    }
  }

  return {
    bind(el, binding, vnode) {
      // 当 value 手动传 false 时，不进行 fixed 操作
      if (binding.value === false) return
      // offset的值
      el.dataset[cacheKey] = binding.value || 0
      if (binding.arg) {
        el.dataset.cls = binding.arg
      }
      const onFixedChange = vnode.context[binding.arg]
      scrollElement = selector ? document.querySelector(selector) : window
      scrollListener = throttle(delay, () => {
        if (!document.body.contains || document.body.contains(el)) {
          elListener(el, onFixedChange)
        }
      })
      scrollElement.addEventListener('scroll', scrollListener, { passive: true })
    },
    componentUpdated(el, binding) {
      if (binding.value === false) return
      el.dataset[cacheKey] = binding.value || 0
    },
    unbind(_el, binding) {
      if (binding.value === false) return
      // 去除scroll监听
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', scrollListener, { passive: true })
        scrollElement = null
        scrollListener = null
      }
    }
  }
}

// 用法
/**
 * v-fixed
 * v-fixed="20" // px
 * v-fixed="cls"
 */
